const updates = [
  {
    date: '2026-07-31',
    tag: '新片上线',
    title: '《谍影谜踪》高清版本正式上线，4K画质体验升级',
    hot: true,
  },
  {
    date: '2026-07-30',
    tag: '剧集更新',
    title: '《长安风云录》更新至第28集，剧情进入白热化阶段',
    hot: true,
  },
  {
    date: '2026-07-29',
    tag: '综艺上线',
    title: '《声动亚洲》第三期上线，实力唱将巅峰对决引爆话题',
    hot: false,
  },
  {
    date: '2026-07-28',
    tag: '动漫更新',
    title: '《灵笼：终章》完结篇上线，三年陪伴迎来圆满结局',
    hot: false,
  },
  {
    date: '2026-07-27',
    tag: '新片上线',
    title: '韩国悬疑片《迷雾追踪》中字版本上线，口碑持续攀升',
    hot: false,
  },
  {
    date: '2026-07-26',
    tag: '站内公告',
    title: '白云视频片库突破两万部，感谢每一位影迷的陪伴与支持',
    hot: false,
  },
  {
    date: '2026-07-25',
    tag: '剧集更新',
    title: '《首尔之恋》更新至第16集，甜蜜剧情持续升温中',
    hot: false,
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            最新动态
          </h2>
        </div>
        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-8">
          <div className="space-y-0">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className={`flex items-start gap-4 py-4 ${
                  idx < updates.length - 1 ? 'border-b border-background-200/60' : ''
                }`}
              >
                <span className="whitespace-nowrap text-xs font-medium text-foreground-400 mt-0.5">
                  {item.date}
                </span>
                <span className={`whitespace-nowrap px-2 py-0.5 rounded text-xs font-medium ${
                  item.hot
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-secondary-100 text-secondary-700'
                }`}>
                  {item.tag}
                  {item.hot && <i className="ri-fire-line ml-1 text-xs"></i>}
                </span>
                <p className="text-sm text-foreground-700 flex-1 leading-relaxed">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}